<template>
  <b-card no-body class="mb-3">
    <b-card-header class="d-flex align-items-center justify-content-between">
      <span class="font-weight-bold">Ranking de Comissoes</span>
      <b-button v-b-toggle="collapseId" size="sm" variant="outline-secondary">
        {{ isOpen ? 'Ocultar' : 'Mostrar' }}
      </b-button>
    </b-card-header>
    <b-collapse :id="collapseId" v-model="isOpen">
      <b-card-body>
        <StateRenderer
          :loading="report.loading"
          :error="report.error"
          :data="summary"
        >
          <b-alert
            v-if="summary.length === 0"
            show
            variant="secondary"
            class="text-center"
          >
            Nenhuma comissao registrada no periodo selecionado
          </b-alert>
          <template v-else>
            <div class="d-md-none">
              <b-card
                v-for="item in rankingItems"
                :key="item.userStoreId || item.userId || item.position"
                class="mb-2"
                body-class="p-2"
              >
                <div class="d-flex align-items-center justify-content-between">
                  <div>
                    <div class="font-weight-bold">{{ item.userName }}</div>
                    <small class="text-muted">
                      Vendas Efetivas: {{ item.totalSales }}
                    </small>
                  </div>
                  <b-badge variant="primary">#{{ item.position }}</b-badge>
                </div>
                <div class="mt-2">
                  <div class="d-flex justify-content-between">
                    <small class="text-muted">Faturamento</small>
                    <strong>{{ item.totalAmount | formatCurrency }}</strong>
                  </div>
                  <div class="d-flex justify-content-between">
                    <small class="text-muted">Ticket medio</small>
                    <span>{{ item.averageTicket | formatCurrency }}</span>
                  </div>
                  <div class="d-flex justify-content-between">
                    <small class="text-muted">Tempo medio</small>
                    <span>{{ formatMinutes(item.averagePeriodMinutes) }}</span>
                  </div>
                </div>
              </b-card>
            </div>

            <div class="d-none d-md-block">
              <b-table
                :fields="fields"
                :items="rankingItems"
                striped
                hover
                small
                responsive
                stacked="md"
                class="mb-0"
              >
                <template #cell(position)="{ index }">
                  <b-badge variant="primary">{{ index + 1 }}</b-badge>
                </template>
                <template #cell(userName)="{ item }">
                  <span class="font-weight-bold">{{ item.userName }}</span>
                </template>
                <template #cell(totalAmount)="{ item }">
                  <span>{{ item.totalAmount | formatCurrency }}</span>
                </template>
                <template #cell(averageTicket)="{ item }">
                  <span>{{ item.averageTicket | formatCurrency }}</span>
                </template>
                <template #cell(averagePeriodMinutes)="{ item }">
                  <span>{{ formatMinutes(item.averagePeriodMinutes) }}</span>
                </template>
              </b-table>
            </div>
          </template>
        </StateRenderer>
      </b-card-body>
    </b-collapse>
  </b-card>
</template>

<script>
import StateRenderer from '@/components/StateRenderer'
import { formatCurrency } from '@/helpers/numbers'

export default {
  name: 'CommissionsRanking',
  components: { StateRenderer },
  filters: { formatCurrency },
  props: {
    report: {
      type: Object,
      required: true
    },
    defaultOpen: {
      type: Boolean,
      default: true
    }
  },
  data() {
    return {
      isOpen: this.defaultOpen
    }
  },
  computed: {
    collapseId() {
      return `commissions-ranking-${this._uid}`
    },
    fields() {
      return [
        {
          key: 'position',
          label: '#',
          thClass: 'text-center',
          tdClass: 'text-center'
        },
        {
          key: 'userName',
          label: 'Funcionario',
          thClass: 'text-left',
          tdClass: 'text-left'
        },
        {
          key: 'totalSales',
          label: 'Vendas Efetivas',
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        {
          key: 'totalAmount',
          label: 'Faturamento',
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        {
          key: 'averageTicket',
          label: 'Ticket medio',
          thClass: 'text-right',
          tdClass: 'text-right'
        },
        {
          key: 'averagePeriodMinutes',
          label: 'Tempo medio',
          thClass: 'text-right',
          tdClass: 'text-right'
        }
      ]
    },
    summary() {
      const data = this.report?.data || {}
      if (Array.isArray(data.summary)) return data.summary
      if (Array.isArray(data)) return data
      return []
    },
    rankingItems() {
      return [...this.summary]
        .sort((a, b) => (b.totalSales || 0) - (a.totalSales || 0))
        .map((item, index) => ({
          ...item,
          position: index + 1
        }))
    }
  },
  methods: {
    formatMinutes(value) {
      const minutes = Number(value)
      if (!Number.isFinite(minutes) || minutes <= 0) return '0 min'
      const totalMinutes = Math.round(minutes)
      const hours = Math.floor(totalMinutes / 60)
      const rest = totalMinutes % 60
      if (hours > 0) {
        return `${hours}h ${rest}min`
      }
      return `${rest} min`
    }
  }
}
</script>
